import { render, staticRenderFns } from "./registerPage.vue?vue&type=template&id=24061536&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"
import style0 from "./registerPage.vue?vue&type=style&index=0&id=24061536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24061536",
  null
  
)

export default component.exports